import type { ClinicalTrialForListingPage } from './fragments/clinicalTrialListingFragment'

export function inferPrimaryConditionFromTrial(
  trial: Pick<ClinicalTrialForListingPage, 'conditions' | 'conjuredTitle'>,
) {
  if (trial.conjuredTitle) {
    const [_, condition] = trial.conjuredTitle.split(' for ')
    if (condition) {
      return condition
    }
  }

  return trial.conditions[0]?.condition.colloquialTermStripped
}
